import { createAction } from "../../utils/redux/createAction";
import { UPDATE_FUNDS_DATA } from "./types";
import { IFundsState, IAction } from "../../ts/redux";

export function updateFundsData(payload: IFundsState): IAction {
    return createAction(UPDATE_FUNDS_DATA, payload);
}